export const getMaxScrollOffset = ({
  scrollEl,
  scrollContainer,
}: {
  scrollEl: HTMLUListElement | null;
  scrollContainer: HTMLDivElement | null;
}): number | undefined => {
  if (!scrollEl || !scrollContainer) return;

  const scrollElWidth = scrollEl.scrollWidth;
  const containerWidth = scrollContainer.clientWidth;
  return Math.max(0, scrollElWidth - containerWidth);
};
